import type { ICourse, ICourseDay } from '../courses';
import type { IExercise } from '../exercises';
import { FOUR_WAY_EPISODE_01_MATERIALS } from './four-way-episode-01-materials';
import { FOUR_WAY_EPISODE_02_MATERIALS } from './four-way-episode-02-materials';
import { FOUR_WAY_EPISODE_03_MATERIALS } from './four-way-episode-03-materials';
import { FOUR_WAY_EPISODE_04_MATERIALS } from './four-way-episode-04-materials';
import { HOME_EPISODE_01_MATERIALS } from './home-episode-01-materials';
import { HOME_EPISODE_02_MATERIALS } from './home-episode-02-materials';
import { HOME_EPISODE_03_MATERIALS } from './home-episode-03-materials';
import { HOME_EPISODE_04_MATERIALS } from './home-episode-04-materials';
import { KAISHENG_EPISODE_01_MATERIALS } from './kaisheng-episode-01-materials';
import { KAISHENG_EPISODE_02_MATERIALS } from './kaisheng-episode-02-materials';
import { KAISHENG_EPISODE_03_MATERIALS } from './kaisheng-episode-03-materials';
import { FANJUE_EPISODE_01_MATERIALS } from './fanjue-episode-01-materials';
import { FANJUE_EPISODE_02_MATERIALS } from './fanjue-episode-02-materials';
import { FANJUE_EPISODE_04_MATERIALS } from './fanjue-episode-04-materials';
import { FANJUE_EPISODE_05_MATERIALS } from './fanjue-episode-05-materials';
import { FANJUE_EPISODE_06_MATERIALS } from './fanjue-episode-06-materials';
import { FANJUE_EPISODE_07_MATERIALS } from './fanjue-episode-07-materials';
import { FANJUE_EPISODE_08_MATERIALS } from './fanjue-episode-08-materials';
import { FANJUE_EPISODE_09_MATERIALS } from './fanjue-episode-09-materials';
import { FANJUE_EPISODE_10_MATERIALS } from './fanjue-episode-10-materials';
import { FANJUE_EPISODE_11_MATERIALS } from './fanjue-episode-11-materials';
import { FANJUE_EPISODE_12_MATERIALS } from './fanjue-episode-12-materials';
import { FANJUE_EPISODE_13_MATERIALS } from './fanjue-episode-13-materials';
import { FANJUE_EPISODE_14_MATERIALS } from './fanjue-episode-14-materials';
import { FANJUE_EPISODE_15_MATERIALS } from './fanjue-episode-15-materials';
import { FANJUE_EPISODE_16_MATERIALS } from './fanjue-episode-16-materials';

const FOUR_WAY = [FOUR_WAY_EPISODE_01_MATERIALS, FOUR_WAY_EPISODE_02_MATERIALS,
  FOUR_WAY_EPISODE_03_MATERIALS, FOUR_WAY_EPISODE_04_MATERIALS];
const HOME = [HOME_EPISODE_01_MATERIALS, HOME_EPISODE_02_MATERIALS,
  HOME_EPISODE_03_MATERIALS, HOME_EPISODE_04_MATERIALS];
const KAISHENG = [KAISHENG_EPISODE_01_MATERIALS, KAISHENG_EPISODE_02_MATERIALS, KAISHENG_EPISODE_03_MATERIALS];
const FANJUE = [FANJUE_EPISODE_01_MATERIALS, FANJUE_EPISODE_02_MATERIALS, [], FANJUE_EPISODE_04_MATERIALS,
  FANJUE_EPISODE_05_MATERIALS, FANJUE_EPISODE_06_MATERIALS, FANJUE_EPISODE_07_MATERIALS,
  FANJUE_EPISODE_08_MATERIALS, FANJUE_EPISODE_09_MATERIALS, FANJUE_EPISODE_10_MATERIALS,
  FANJUE_EPISODE_11_MATERIALS, FANJUE_EPISODE_12_MATERIALS, FANJUE_EPISODE_13_MATERIALS,
  FANJUE_EPISODE_14_MATERIALS, FANJUE_EPISODE_15_MATERIALS, FANJUE_EPISODE_16_MATERIALS];

/** Course occurrences stay independent even where two teachers teach the same movement. */
export const ORDERED_COLLECTION_MATERIALS: IExercise[] = [...FOUR_WAY, ...HOME, ...KAISHENG, ...FANJUE].flat();
const SINGLE_EPISODES: Record<string, IExercise[]> = {
  'home-push': HOME[0], 'home-pull': HOME[1], 'home-lower-body': HOME[2], 'home-shoulder-arm': HOME[3],
  'ksw-collection-push': KAISHENG[0], 'ksw-collection-pull': KAISHENG[1], 'ksw-collection-legs': KAISHENG[2],
};

function replaceDay(day: ICourseDay, entries: IExercise[]): ICourseDay {
  // The detailed upload list puts all warmup items first. Do not sort or deduplicate occurrences.
  return { ...day, warmupIds: entries.filter(entry => entry.isWarmup).map(entry => entry.id),
    mainIds: entries.filter(entry => !entry.isWarmup).map(entry => entry.id), stretchIds: [] };
}

export function withOrderedCollectionMaterials(course: ICourse): ICourse {
  const single = SINGLE_EPISODES[course.id];
  if (single) return { ...course, days: course.days.map(day => replaceDay(day, single)) };
  if (course.id === 'four-way-collection') {
    return { ...course, days: course.days.map((day, index) => replaceDay(day, FOUR_WAY[index])) };
  }
  if (course.id === 'fanjue-plan') {
    return { ...course, days: course.days.map((day, index) => index === 2
      ? { ...replaceDay(day, []), name: '第03期 · 背部最实用模式（整课视频待补充）', focus: '背部最实用模式' }
      : replaceDay(day, FANJUE[index])) };
  }
  return course;
}
